import { ApiService } from '../../app-lite/api/api.service';

import VendorInvoiceHtml from './vendor-invoice.html';

export function VendorInvoicesStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'vendorInvoiceCtrl',
    name      : 'app.vendor-invoice',
    params    : {
      acquisition_id: { squash: true, value: null },
      id            : { squash: true, value: null },
      vendor_id     : { squash: true, value: null }
    },
    templateUrl: VendorInvoiceHtml,
    url        : '/:vendor_id/vendor_invoice/:id/:acquisition_id',
    resolve    : {
      dealership  : ( $rootScope : any, workshopAPI : ApiService ) : ng.IPromise<any> => $rootScope.Company.hasDealership() ? workshopAPI.get('/dealership_setting') : null,
      invoiceTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vendor_invoice_types/', null, 'invoice_types'),
      paymentTerms: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/payment_term_types', null, 'paymentTerms'),
      payments    : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/vendor_invoices/payments_for_vendor_invoice_list', [ $stateParams.id, 0, 5, 'post_date', 'desc' ])
          : [],
      vendor: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.vendor_id
          ? workshopAPI.get('/vendor', $stateParams.vendor_id)
          : {},
      vendor_credits: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
        ? workshopAPI.get('vendor_credit_application_items/vendor_invoice_credit_list', [$stateParams.id, 0, 6])
        : [],
      vendor_invoice: ( $stateParams : ng.ui.IStateParamsService, VendorInvoice, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const copy = new VendorInvoice().getCopy();

        return $stateParams.id
          ? copy || workshopAPI.get('/vendor_invoice', $stateParams.id)
          : copy;
      }
    }
  });
}